import { QueryClient } from 'react-query';

export function invalidateTaskCaches(
  queryClient: QueryClient,
  taskIds?: string[]
) {
  taskIds?.forEach((id) => {
    queryClient.invalidateQueries(['task', id]);
  });

  queryClient.invalidateQueries(['taskEvents']);
  queryClient.invalidateQueries(['summaries']);
  queryClient.invalidateQueries(['infos']);
  queryClient.invalidateQueries(['schedule-data']);
  queryClient.invalidateQueries(['schedule-data-infinite']);
}
